import { CircularProgress, Grid, Typography, Button } from '@material-ui/core/';
import React, { FC, useContext } from 'react';
import Auth0LockContext, { isAuthenticated } from 'Auth0LockContext';
import LineItemCard from 'components/SalesArea/pages/Cart/LineItemCard';
import {
  CheckoutFragmentFragment,
  CheckoutLineItem,
} from 'graphql/shopify-store-front-api/queries/types';
import AddToCartEvent, { Item } from '../../../Common/Gtag/AddToCart';

export type Props = {
  /**
   * 次のページへ切り替える関数
   */
  nextPagingFunction: VoidFunction;

  /**
   * 前のページへ切り替える関数
   */
  previousPagingFunction: VoidFunction;

  /**
   * 表示するカート情報
   */
  checkout: CheckoutFragmentFragment | undefined;

  /**
   * ロード中であるかを示す真偽値
   */
  isLoading: boolean;
};

/**
 * カート情報を表示するコンポーネント
 */
const Cart: FC<Props> = ({
  nextPagingFunction,
  previousPagingFunction,
  checkout,
  isLoading,
}) => {
  const auth0Lock = useContext(Auth0LockContext);
  localStorage.removeItem('auth_show');

  const ItemLists = checkout?.lineItems.edges.map((item) => {
    return {
      id: item.node.id,
      name: item.node.title,
      price: item.node.variant?.priceV2.amount as number,
      quantity: item.node.quantity,
    };
  });

  return (
    <>
      <br />
      {/* ロード中の場合 */}
      {isLoading && (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      )}
      {/* ロード中では無い場合 */}
      {!isLoading && (
        <>
          {checkout && checkout.lineItems.edges.length > 0 ? (
            // カートに商品がある場合
            <>
              {checkout.lineItems.edges.map((lineItem) => (
                <Grid
                  container
                  justify="center"
                  key={lineItem.node.variant?.id}
                >
                  <LineItemCard lineItem={lineItem.node as CheckoutLineItem} />
                </Grid>
              ))}
              <Grid container justify="center">
                <Typography gutterBottom variant="h5">
                  合計：¥
                  {Number(checkout?.totalPriceV2.amount).toLocaleString()}
                </Typography>
              </Grid>
              <Grid container justify="center">
                <Typography>※送料は配送先住所確定後に加算されます</Typography>
              </Grid>
            </>
          ) : (
            // カートに商品が無い場合
            <Grid container justify="center">
              カートに商品はありません
            </Grid>
          )}

          <Grid container justify="center" spacing={8}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => previousPagingFunction()}
              >
                商品一覧に戻る
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (!isAuthenticated()) {
                    localStorage.setItem('auth_show', 'true');
                    auth0Lock.client.show({ rememberLastLogin: false });
                  } else {
                    nextPagingFunction();
                    AddToCartEvent({
                      value: (checkout?.totalPriceV2.amount as number) ?? 0,
                      // items: (checkout?.lineItems.edges as Item[]) ?? '',
                      items: ItemLists as Item[],
                    });
                  }
                }}
                disabled={!checkout || checkout.lineItems.edges.length < 1}
              >
                レジへ進む
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Cart;
